@if (loading()) {
  <app-loading />
} @else {
  <app-failure-message>
    <h1 class="mt-3 mt-lg-0 reject" [innerHTML]="'ErrorComponent.header' | translate"></h1>
    <p class="text-bigger mt-2 mb-0">
      @if (loan()) {
        {{ 'ErrorComponent.text1' | translate }}
        <a [href]="link()">{{ link() }}</a>
      }
      @if (!loan()) {
        {{ 'ErrorComponent.text2' | translate }}
      }
    </p>
    @if (api.error$?.(); as error) {
      <div class="text-center error my-2" id="error">{{ error | translate }}</div>
    }
  </app-failure-message>
}
